<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Sheet, SheetHeader, SheetTitle, SheetContent } from "@/components/ui/sheet";
import TicketDetails from "./TicketDetails.vue";
import TicketForm from "./TicketForm.vue";

interface Props {
  customerId: string;
}

defineProps<Props>();

const route = useRoute();
const router = useRouter();

const ticketId = route.params.ticketId as string;
const ticketTitle = ref<string>("New Ticket");
</script>

<template>
  <Sheet :default-open="true" @update:open="router.push({ name: 'customerSupport', params: { customerId } })">
    <SheetContent class="overflow-y-scroll p-6 sm:max-w-1/2">
      <SheetHeader class="p-0">
        <SheetTitle :class="[route.name !== 'newTicket' && 'break-words']">{{ ticketTitle }}</SheetTitle>
      </SheetHeader>
      <TicketDetails v-if="route.name === 'ticket' && ticketId" v-model:title="ticketTitle" :customer-id :ticket-id />
      <TicketForm v-else v-model:title="ticketTitle" :customer-id :ticket-id />
    </SheetContent>
  </Sheet>
</template>
